import React, { Component } from 'react';
import { Common } from '../../core/common';
import { Log } from 'ng2-logger';
import Translator from '../../core/i18n';
import { Input as InputReact, Modal } from 'reactstrap';
import Input from '../../components/input/text/input-formik';
import { Button } from '../../components/ui-elements/main';
import { Notification } from '../../components/notification/main';

const T = Translator.create();
const _logger = Log.create('Home Box Messages');
let _common: Common;
export class TwoFactorMail extends Component<any> {
    timer: any;
    public state = {
        codeScreenStatus: false,
        isVerificationCodeConfirmed: false,
        timeLeft: 120,   // second
        twoFactorVerificationError: '',
    }
    public constructor(props: any) {
        super(props);
        _common = new Common();
        this.timer = null;
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    resetFunction = () => {
        this.props.resetErrorMessage()
    }

    componentDidUpdate(prevProps: any, prevState: any, snapshot?: any): void {
        if (this.props.formik.values.twoFactorVerificationError?.length > 0) {
            this.setState({ twoFactorVerificationError: this.props.formik.values.twoFactorVerificationError, timeLeft: 0 }, this.resetFunction)
        }
    }

    emailButtonClicked = () => {

        const { twoFactorAuthMailAddress } = this.props.formik.values;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (twoFactorAuthMailAddress === '' || !twoFactorAuthMailAddress) {
            return Notification.setNotification('error', T.t('r_email_required'), 'topRight');
        }

        if (!emailRegex.test(twoFactorAuthMailAddress)) {
            return Notification.setNotification('error', T.t('r_invalid_email_format'), 'topRight');
        }

        this.props.sendVerificationCode(this.props.formik.values.twoFactorAuthMailAddress, true, this.sendVerificationCodeCallbackFunction)
    }

    handleCodeScreenStatus = (status: boolean) => {
        this.setState({ codeScreenStatus: status });
    }

    sendVerificationCodeCallbackFunction = (value: boolean) => {
        if (value) {
            this.setState({ isVerificationCodeConfirmed: true, codeScreenStatus: true })
            this.startCountdown();
        }
    }

    callbackFunction = () => {
        if (!this.state.twoFactorVerificationError || this.state.twoFactorVerificationError.length === 0) {
            this.props.formik.setFieldValue("twoFactorAuthMailAddress_checked", this.props.formik.values.twoFactorAuthMailAddress)
            this.props.onClickTwofactorModel(false)
        }
    }

    checkVerificationCode = () => {
        this.props.checkVerificationCode(this.props.formik.values.userName, this.props.formik.values.twoFactorCode, this.callbackFunction)
        this.props.resetErrorMessage()
    }


    resendVerificationCode = () => {
        this.setState({ timeLeft: 120, twoFactorVerificationError: '' }, this.startCountdown)
        this.props.sendVerificationCode(this.props.formik.values.twoFactorAuthMailAddress, true)
    };

    startCountdown = () => {
        this.setState({ timeLeft: 120 });
        this.timer = setInterval(() => {
            this.setState((prevState: any) => {
                if (prevState.timeLeft <= 0) {
                    clearInterval(this.timer);
                    return { timeLeft: 0 };
                }
                return { timeLeft: prevState.timeLeft - 1 };
            });
        }, 1000);
    };

    formatTime = (time: number) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds
            .toString()
            .padStart(2, '0')}`;
    };

    validateTwoFactorAuthMailAddress = (value: string) => {
        this.props.formik.setFieldValue('twoFactorAuthMailAddress', value);
    };

    cancelTwoFactorAuth = () => {
        this.props.formik.setFieldValue('twoFactorAuthMailAddress', '');
        this.props.onClickTwofactorModel(false)
    }

    public render() {

        const { timeLeft } = this.state;

        return (
            <Modal
                className="pt-0"
                style={{ maxWidth: '550px', margin: '0 auto', marginTop: "50px", height: "100%" }}
                isOpen={true}
                fade={true}
                backdrop={'static'}>
                <div className="white-box" style={{ padding: "15px", height: "100%" }}>
                    <div className="d-flex justify-content-between white-box-header">
                        <div>
                            <h2>
                                {T.t('r_add_two_factor_address_define')}
                            </h2>

                        </div>
                        <div className="align-self-center">
                            <a onMouseDown={event => this.cancelTwoFactorAuth()} >
                                <i className="material-icons ml-2 align-middle">close</i>
                            </a>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between white-box-header" dangerouslySetInnerHTML={{ __html: T.t('r_add_two_factor_address_define_info') }}>
                    </div>
                    <div style={{ marginTop: "35px" }}>
                        {!this.state.codeScreenStatus ?
                            <Input
                                type={'text'}
                                name={'twoFactorAuthMailAddress'}
                                label={T.t('r_email_adress')}
                                formik={this.props.formik}
                                value={this.props.formik.values.twoFactorAuthMailAddress || ""}
                                onChange={(e: any) => {
                                    const value = e.target.value;
                                    this.validateTwoFactorAuthMailAddress(value);
                                }}
                            />
                            :
                            <div className='d-flex'>
                                <div className='col-md-1 d-flex justify-content-center align-items-start' style={{ cursor: "pointer" }} onMouseDown={e => this.handleCodeScreenStatus(false)}>
                                    <Button
                                        button_type='secondary'
                                        size={'medium'}
                                        iconPosition='left'
                                        materialicon='chevron_left'
                                        style={{ marginTop: "10px" }}
                                    />

                                </div>
                                <div className='col-md-11'>
                                    <div className="k365-input">
                                        <label className='input-label'>{T.t('r_add_two_factor_code_enter')}</label>
                                        <InputReact
                                            type={'text'}
                                            name={'twoFactorCode'}
                                            placeHolder={T.t('r_add_two_factor_code_enter')}
                                            formik={this.props.formik}
                                            onBlur={(e: any) => {
                                                const value = e.target.value;
                                                this.props.formik.setFieldValue('twoFactorCode', value);
                                            }}
                                            onClickCapture={() => this.setState({ twoFactorVerificationError: '' })}
                                        />
                                    </div>
                                </div>

                            </div>
                        }

                    </div>
                    {(!this.props.formik.errors.email && !this.state.codeScreenStatus) ?
                        <div className="d-flex w-100 justify-content-center">
                            <Button
                                button_type='primary'
                                text={T.t('r_send_two_factor_code')}
                                size={'medium'}
                                iconPosition='left'
                                onMouseDown={() => this.emailButtonClicked()}
                                materialicon='send'
                                style={{ marginTop: "10px" }}
                            />
                        </div>
                        :
                        <div
                            className="d-flex flex-column align-items-center"
                            style={{
                                marginTop: "40px",
                                paddingBottom: "10px",
                            }}
                        >
                            {this.state.twoFactorVerificationError?.length > 0 && (
                                <span style={{ color: "red", marginBottom: "10px" }}>
                                    {this.state.twoFactorVerificationError}
                                </span>
                            )}

                            <Button
                                button_type='secondary'
                                text={T.t('r_add_two_factor_code_resend')}
                                size={'medium'}
                                iconPosition='left'
                                materialicon='autorenew' disabled={timeLeft > 0}
                                onClick={() => {
                                    if (timeLeft === 0) {
                                        this.resendVerificationCode()
                                    }
                                }}
                            />
                            {timeLeft > 0 && (
                                <span>
                                    &nbsp;({this.formatTime(timeLeft)})
                                </span>
                            )}
                        </div>
                    }
                    <div></div>

                    <div className="social-footer" style={{ marginTop: "60px" }}>
                        <div className="activity-footer d-flex justify-content-between">
                            <div className="mini-btn">
                                <Button
                                    button_type='secondary'
                                    onClick={() => this.cancelTwoFactorAuth()}
                                    text={T.t('r_cancel_button')}
                                    size={'medium'}
                                    iconPosition='left'
                                    materialicon='close'
                                />
                            </div>
                            <div className="mini-btn text-md-right">
                                <Button
                                    button_type='primary'
                                    text={T.t('r_save_button')}
                                    size={'medium'}
                                    iconPosition='left'
                                    materialicon='save'
                                    disabled={!this.state.isVerificationCodeConfirmed}
                                    onClick={() => { this.checkVerificationCode() }}
                                />
                            </div>
                        </div>
                    </div>
                </div>


            </Modal>
        );
    }
}


export default TwoFactorMail;
